import { QueryFunction, useQuery } from "@tanstack/react-query";

const useService = (label: string, fnActions: QueryFunction) => {
    const serviceQuery = useQuery(
        [label],
        fnActions,
    );
    return serviceQuery;
}

export { useService }